export default {
	type: 'object',
	properties: {
		campaignId: { type: 'string' },
		brandId: { type: 'string' },
	},
	required: ['brandId', 'campaignId'],
	additionalProperties: false,
}
